document.addEventListener("DOMContentLoaded", function () {
  var nav = document.querySelector(".custom-navigation");
  var announcementBar = document.querySelector(".announcement-bar");
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 48;

  // --- Initial top positioning ---
  if ((window.scrollY || document.documentElement.scrollTop) === 0) {
    nav.style.top = announcementHeight + "px"; // first visit at top
  } else {
    nav.style.top = "0px"; // page loaded scrolled
  }

  // --- Fade in after setting top ---
  setTimeout(function () {
    nav.classList.add("show");
  }, 50); // small delay to ensure top is applied

  // --- Smooth updates on scroll ---
  window.addEventListener("scroll", function () {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var newTop = Math.max(announcementHeight - scrollTop, 0);
    nav.style.top = newTop + "px";
  });

  // --- Update on resize ---
  window.addEventListener("resize", function () {
    announcementHeight = announcementBar ? announcementBar.offsetHeight : 48;
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    nav.style.top = Math.max(announcementHeight - scrollTop, 0) + "px";
  });

  // For mobile menu toggle feature
  const menuBtn = document.querySelector(".hamburger-btn");
  const mobileMenu = document.querySelector(".custom-navigation__mobile-menu");
  const hamburgerIcon = document.querySelector(".hamburger-icon");
  const closeIcon = document.querySelector(".close-icon");
  const body = document.body;
  const mobileToggleBtn = document.querySelector(
    ".easysearch-mobile-nav-click"
  );
  const mobileToggleTitle = document.querySelector(
    ".easysearch-mobile-nav-title"
  );
  const findDealerBtn = document.querySelector(
    ".custom-navigation__find-dealer-mobile"
  );
  const easySearchNavForm = document.querySelector(
    ".easysearch-navigation-block"
  );
  const detailsWrapper = document.querySelector(
    ".mega-menu-mobile__details-wrapper"
  );
  const menusWrapper = document.querySelector(
    ".mega-menu-mobile__menus-wrapper"
  );

  menuBtn.addEventListener("click", function () {
    const isMenuCurrentlyOpen = mobileMenu.classList.contains("active");

    if (!isMenuCurrentlyOpen) {
      // จัดการเรื่อง annountment bar โดย เช็คกว่า page นั้นถูก scroll ลงมายัง
      // ถ้ายัง - scroll ลงมาเท่ากับ announcement bar ก่อนเปิด menu
      // ถ้า scroll ลงมามากกว่า announcement bar แล้ว ให้เปิด menu ได้เลย
      const currentScroll =
        window.scrollY || document.documentElement.scrollTop;

      if (currentScroll < announcementHeight) {
        window.scrollTo({
          top: announcementHeight,
          behavior: "smooth",
        });

        setTimeout(() => {
          openMobileMenu();
        }, 300);
      } else {
        openMobileMenu();
      }
    } else {
      closeMobileMenu();
    }

    function openMobileMenu() {
      mobileMenu.classList.add("active");
      mobileToggleBtn.style.display = "none";
      findDealerBtn.style.display = "block";
      hamburgerIcon.style.display = "none";
      closeIcon.style.display = "block";
      body.classList.add("no-scroll");
      easySearchNavForm.classList.add("easy-hidden");
    }

    function closeMobileMenu() {
      mobileMenu.classList.remove("active");
      mobileToggleBtn.style.display = "block";
      findDealerBtn.style.display = "none";
      hamburgerIcon.style.display = "block";
      closeIcon.style.display = "none";
      body.classList.remove("no-scroll");
      mobileToggleBtn.textContent = "คลิก เพื่อเลือก";
      detailsWrapper.classList.add("hidden");
      menusWrapper.classList.remove("hidden");
    }
  });

  mobileToggleTitle.addEventListener("click", function () {
    mobileToggleBtn.style.display = "block";
    mobileMenu.classList.remove("active");
    findDealerBtn.style.display = "none";
    hamburgerIcon.style.display = "block";
    closeIcon.style.display = "none";
    body.classList.remove("no-scroll");
    detailsWrapper.classList.add("hidden");
    menusWrapper.classList.remove("hidden");
  });

  // Hover effect + animation for mega menu - desktop
  document.querySelectorAll(".custom-navigation__item").forEach((item) => {
    const megaMenu = item.nextElementSibling;
    const easySearchNavForm = document.querySelector(
      ".easysearch-navigation-block"
    );

    if (
      megaMenu &&
      megaMenu.classList.contains("custom-navigation__mega-menu")
    ) {
      item.addEventListener("mouseenter", () => {
        item.classList.add("active-hover");
        megaMenu.style.display = "block"; // Show it first to allow animations
        setTimeout(() => {
          megaMenu.classList.add("show"); // Apply fade-in effect
        }, 10);
        body.classList.add("no-scroll");
        easySearchNavForm.classList.add("easy-hidden"); // Hide easysearch widget
      });

      megaMenu.addEventListener("mouseenter", () => {
        item.classList.add("active-hover");
        body.classList.add("no-scroll");
      });

      item.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!megaMenu.matches(":hover")) {
            megaMenu.classList.remove("show"); // Start fade-out effect
            setTimeout(() => {
              if (!megaMenu.classList.contains("show")) {
                megaMenu.style.display = "none"; // Hide it after animation
              }
            }, 300);
            item.classList.remove("active-hover");
            body.classList.remove("no-scroll");
          }
        }, 10);
      });

      megaMenu.addEventListener("mouseleave", () => {
        megaMenu.classList.remove("show");
        setTimeout(() => {
          if (!megaMenu.classList.contains("show")) {
            megaMenu.style.display = "none";
          }
        }, 300);
        item.classList.remove("active-hover");
        body.classList.remove("no-scroll");
      });
    }
  });
});
